export default "__VITE_ASSET__C2nlsJR6__"